var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_32248)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 21,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8571 13.1H0V8.9H12.8571V0.5H17.1429V8.9H30V13.1H17.1429V21.5H12.8571V13.1Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4285 15.8998H19.9999V17.2998H21.4285V18.6998H22.8571V17.2998H24.2857V15.8998H22.8571V14.4998H21.4285V15.8998ZM21.4285 4.6998H19.9999V6.0998H21.4285V7.4998H22.8571V6.0998H24.2857V4.6998H22.8571V3.2998H21.4285V4.6998ZM7.1428 4.6998H5.71423V6.0998H7.1428V7.4998H8.57138V6.0998H9.99995V4.6998H8.57138V3.2998H7.1428V4.6998ZM7.1428 15.8998H5.71423V17.2998H7.1428V18.6998H8.57138V17.2998H9.99995V15.8998H8.57138V14.4998H7.1428V15.8998Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_32248"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 21,
    rx: 3,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngland);
export default __webpack_public_path__ + "static/media/england.2ec0a6550aff35ee10b51790b4c2b2a8.svg";
export { ForwardRef as ReactComponent };